<template>
  <div class="knowledge">
    <h2 class="mb-8">{{ $ucfirst($t("screens.increaseYourKnowledgeSettingScreen", { catalog: 'app_mobile' })) }}</h2>
    <knowledge-button-line />
    <router-view></router-view>
    <discussion-step-nav-buttons
      :nextRoutes="nextDiscussionStep"
      :prevRoutes="prevDiscussionStep"
    >
    </discussion-step-nav-buttons>
  </div>
</template>

<script>
import DiscussionStepNavButtons from '../../../components/Parts/DiscussionStepNavButtons.vue';
import KnowledgeButtonLine from "../../../components/Parts/KnowledgeButtonLine";

/**
 * Component PatientOverviewKnowledge.vue
 *
 * @module PatientOverviewKnowledge
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/APP_DASHBOARD/templates/views/Patient/Knowledge/PatientOverviewKnowledge.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientOverviewKnowledge',
  props: ['nextDiscussionStep', 'prevDiscussionStep'],
  components: {
    KnowledgeButtonLine,
    DiscussionStepNavButtons
  },
}
</script>
